module.exports = __webpack_public_path__ + "static/media/nFocusLogo.90383eb8.svg";